import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, Grid } from 'semantic-ui-react';
import InfoIcon from '@material-ui/icons/Info';
import $ from "jquery";

import Title from '../../title';
import Server from '../../../functions/server';
import Loading from '../../loading';
import Permission from '../../../functions/permission';
import CustomerDetails from '../../others/customerdetails';

class SalesGSTReport extends Component {

  state = {
    report: [], customerData: {}
  }


  getGstReport = (id) => {
    let context = this;
    $.ajax({
      type: 'POST', data: { id },
      url: Server() + 'salesreport/getdetails.php',
      success: function(data) {
        context.setState({ dialog: true })
        try {
          data = JSON.parse(data);
          let customerData = {};
          let i = 1;
          data.map((c) => { if (i == 1) { i = i + 1; customerData = c; } })
          console.log(customerData);
          context.setState({ customerData, report: data })
        } catch (e) {
        }
      },
      error: function(err)
      {
        alert('Try again!!!!')
      }
    });
  }

  convertIntoNumber = (value) => {
    try {
        value = Number(value);
    } catch (error) {
        value = 0;
    }
    return value;
  }

  makeDecimalPoint = (value) => {
    try {
        value = value.toFixed(2);
    } catch (error) {
        value = 0;
    }
    return value;
  }

  filterReport = () => {
    let report = this.state.report;
    let hsncodearray = report.filter((v,i,a)=>a.findIndex(t=>(t.hsn_code === v.hsn_code))===i)
    hsncodearray.map((c) => {
        let beforetax = 0;
        let taxAmount = 0;
        let aftertax = 0;
        report.map((v) => {
            if (c.hsn_code == v.hsn_code) {
                let amount = this.convertIntoNumber(v.totprice);
                let tax = this.convertIntoNumber(v.taxs);
                let taxs = this.convertIntoNumber(v.taxs);
                if (taxs < 10) {
                    taxs = "1.0"+taxs;
                }
                else {
                    taxs = "1."+taxs;
                }
                taxs = this.convertIntoNumber(taxs);
                let beforetaxamount = (amount/taxs);
                aftertax = aftertax + amount; 
                beforetax = beforetax + beforetaxamount; 
            }
        })
        c.aftertax = aftertax;
        c.beforetax = beforetax;
        c.taxamount = aftertax - beforetax;
    })
    return hsncodearray;
  }

    render() {
        let { dialog, customerData, report } = this.state;
        let i = 1;
        let reports = this.filterReport();
        let overallbeforeamount = 0;
        let overallafteramount = 0;
        let overalltaxamount = 0;
        return (
            <div>
                <center>
                    <InfoIcon onClick={ () => this.getGstReport(this.props.item.id)} style={{cursor: 'pointer'}} />
                    <Dialog fullWidth={true}  maxWidth={'lg'}
                        open={dialog} onClose={ () => { this.setState({ dialog: false }) }} 
                        aria-labelledby="max-width-dialog-title">
                        <DialogTitle id="max-width-dialog-title">HSNCODE REPORT</DialogTitle>
                        <DialogContent>
                            <Grid>
                                <Grid.Column mobile={16} tablet={16} computer={4}>
                                    <b>{'Customer Name : '+customerData.name+"->"+this.props.item.customer_id}</b>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={4}>
                                    <b>{'Customer Mobile : '+customerData.mobile}</b>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={4}>
                                    <b>{'Customer Taluk : '+customerData.taluk}</b>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={4}>
                                    <b>{'Customer District : '+customerData.district}</b>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={4}>
                                    <b>{'Customer GSTIN : '+customerData.GSTIN}</b>
                                </Grid.Column>
                                <Grid.Column mobile={16} tablet={16} computer={16}>
                                    <table width="100%" id="table">
                                        <tr>
                                            <th id='tableheader'><center>Sino</center></th>
                                            <th id='tableheader'><center>HSNCODE</center></th>
                                            <th id='tableheader'><center>TAX</center></th>
                                            <th id='tableheader'><center>BEFORE TAX</center></th>
                                            <th id='tableheader'><center>TAX AMOUNT</center></th>
                                            <th id='tableheader'><center>AFTER TAX</center></th>
                                        </tr>
                                        {
                                            reports.map((c) => {
                                                console.log(JSON.stringify(c));
                                                console.log('-------------------------');
                                                overallbeforeamount = overallbeforeamount + c.beforetax;
                                                overallafteramount = overallafteramount + c.aftertax;
                                                overalltaxamount = overalltaxamount + c.taxamount;
                                                return (
                                                    <tr>
                                                        <td>{i++}</td>
                                                        <td>{ c.comments ? c.ohsncode : c.hsn_code}</td>
                                                        <td>{c.taxs}</td>
                                                        <td style={{textAlign: 'right'}}>{this.makeDecimalPoint(c.beforetax)}</td>
                                                        <td style={{textAlign: 'right'}}>{this.makeDecimalPoint(c.taxamount)}</td>
                                                        <td style={{textAlign: 'right'}}>{this.makeDecimalPoint(c.aftertax)}</td>
                                                    </tr>
                                                )
                                            })
                                        }

                                        <tr>
                                            <td>{}</td>
                                            <td><b>Total</b></td>
                                            <td></td>
                                            <td style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeDecimalPoint(overallbeforeamount)}</td>
                                            <td style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeDecimalPoint(overalltaxamount)}</td>
                                            <td style={{textAlign: 'right', fontWeight: 'bold'}}>{this.makeDecimalPoint(overallafteramount)}</td>
                                        </tr>

                                    </table>
                                </Grid.Column>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                        </DialogActions>
                    </Dialog>
                </center>
            </div>
        );
    }
}

export default SalesGSTReport;
